export interface Address {
  street: string;
  houseNumber: string;
  postalCode: string;
  city: string;
  country: string;
}

export type CompanyStatus =
  | 'DEMO_REQUESTED'
  | 'DEMO_CONTACTED'
  | 'DEMO_SCHEDULED'
  | 'DEMO_COMPLETED'
  | 'DEMO_DECLINED'
  | 'pending'
  | 'active'
  | 'inactive';

/**
 * Demo requests still waiting on someone. COMPLETED and DECLINED are finished, so
 * counting them would show work that no longer exists.
 *
 * Badge and filter both derive from this: they used to disagree - the badge counted
 * every DEMO_* status while the filter matched only DEMO_REQUESTED - so a completed
 * demo raised the badge but produced an empty list when clicked.
 */
export const OPEN_DEMO_STATUSES: readonly CompanyStatus[] = [
  'DEMO_REQUESTED',
  'DEMO_CONTACTED',
  'DEMO_SCHEDULED',
];

export function isOpenDemo(status: CompanyStatus): boolean {
  return OPEN_DEMO_STATUSES.includes(status);
}

export type ContactPreference = 'phone' | 'email' | 'video' | 'inperson';

export interface DemoActivity {
  id: string;
  timestamp: string;
  action: string;
  note?: string;
  performedBy?: string;
}

export interface DemoSchedule {
  scheduledAt: string;
  scheduledType: ContactPreference;
}

export interface Company {
  id: string;
  name: string;
  legalForm: string;
  billingAddress: Address;
  phone: string;
  website: string;
  email: string;
  status: CompanyStatus;
  stripeCustomerId?: string;
  createdAt: string;
  updatedAt: string;
  // Demo-specific fields
  source?: 'haendler' | 'restaurant';
  industry?: string;
  contactPreference?: ContactPreference;
  demoMessage?: string;
  contactFirstName?: string;
  contactLastName?: string;
  demoActivities?: DemoActivity[];
  demoSchedule?: DemoSchedule;
}

export interface CompanyWithDetails extends Company {
  shops: Shop[];
  owners: Owner[];
}

export interface Shop {
  id: string;
  companyId: string;
  address: Address;
  email: string;
  phone: string;
}

export interface Owner {
  id: string;
  companyId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
}
